export type PetObjectKind = 'bowl' | 'house';
export interface PetObject { placed: boolean; x: number; y: number }
export interface PetRoom { bowl: PetObject; house: PetObject; portions: number }
export interface PetPoint { x: number; y: number }
export interface PetPlacement { kind: PetObjectKind; pointer?: { id: number; x: number; y: number } }
export const PET_OBJECTS: { id: PetObjectKind; label: string; description: string }[] = [
  { id: 'bowl', label: 'Миска', description: 'Три порции угощения. Проголодавшись, питомец подойдёт поесть.' },
  { id: 'house', label: 'Домик', description: 'Уютное место для сна. Здесь питомец отдыхает и восстанавливает силы.' },
];
export const defaultPetRoom = (): PetRoom => ({
  bowl: { placed: false, x: .76, y: .96 }, house: { placed: false, x: .2, y: .96 }, portions: 3,
});
const unit = (value: unknown, fallback: number) => typeof value === 'number' && Number.isFinite(value) ? Math.max(0, Math.min(1, value)) : fallback;
export function normalizePetRoom(value: unknown): PetRoom {
  const result = defaultPetRoom();
  const raw = value && typeof value === 'object' ? value as Record<string, unknown> : {};
  for (const { id } of PET_OBJECTS) {
    const item = raw[id] && typeof raw[id] === 'object' ? raw[id] as Record<string, unknown> : {};
    result[id] = { placed: item.placed === true, x: unit(item.x, result[id].x), y: unit(item.y, result[id].y) };
  }
  if (typeof raw.portions === 'number' && Number.isFinite(raw.portions)) result.portions = Math.max(0, Math.min(3, Math.floor(raw.portions)));
  return result;
}
export function petObjectSize(kind: PetObjectKind, viewportWidth: number) {
  const compact = viewportWidth < 640;
  return kind === 'bowl' ? { width: compact ? 64 : 80, height: compact ? 42 : 52 } : { width: compact ? 128 : 160, height: compact ? 112 : 140 };
}
/** X — середина предмета, Y — нижний край. Доли экрана переживают смену размера окна. */
export function petObjectRect(kind: PetObjectKind, point: PetPoint, viewport: { width: number; height: number }) {
  const { width, height } = petObjectSize(kind, viewport.width);
  const left = Math.max(8, Math.min(Math.max(8, viewport.width - width - 8), point.x * viewport.width - width / 2));
  const top = Math.max(52, Math.min(Math.max(52, viewport.height - height - 8), point.y * viewport.height - height));
  return { left, top, width, height, right: left + width, bottom: top + height };
}
